import FetcherTableSkeleton from "../FetcherTableSkeleton";

/** Placeholder that mirrors ConfigsTable while the catalogue is loading. */
const ConfigsSkeleton = () => <FetcherTableSkeleton columns={6} />;

export default ConfigsSkeleton;
